<template>
    <div v-show="active" @click.stop="close()">
        <div >
            <slot></slot>
        </div>
    </div>
</template>
<script>
//多层弹窗
export default {
    data() {
        return {
            containerTitle: '',
            active: this.value
        }
    },
    props: {
        value: {
            type: Boolean
        },
        title: {
            type: String
        },
        //手动关闭：默认自动关闭
        selfClose:{
            type:Boolean

        }
    },
    created() {
        this.$store.commit('togglePopup', this.value);
        this.$bus.$on('closePupup', () => {
            this.active = false;
        });
    },
    mounted() {
        if (this.value) {
            setTimeout(() => {
                this.containerTitle = document.getElementById('gwi-title').innerHTML;
                document.getElementById('gwi-title').innerHTML = this.title;
            });
        }
    },
    watch: {
        value(val) {
            this.active = val;
            this.$store.commit('togglePopup', val);
        },
        active(val) {
            this.$emit('input', val);
            if (!this.containerTitle) {
                this.containerTitle = document.getElementById('gwi-title').innerHTML;
            }
            if (this.title) {
                var tmpTitle = val ? this.title : this.containerTitle;
                document.getElementById('gwi-title').innerHTML = tmpTitle;
            }
        }
    },
    methods: {
        close() {
            if(!this.selfClose){
                this.active = false;
            }
            sessionStorage.setItem('directFromPopup', 1)
        }
    }
}
</script>



// WEBPACK FOOTER //
// Popup.vue?12a1f5f6